// src/services/metaPixel.ts
// Pixel Meta (Facebook) — chargé uniquement si VITE_FACEBOOK_PIXEL_ID est défini.
// L'ID de pixel est PUBLIC (exposé côté client par conception) → OK dans l'env Vite.
//
// SPA : le PageView initial est déclenché ici à l'init ; les changements de route
// sont suivis par <RouteTracker> dans App.tsx. Les événements e-commerce standard
// (ViewContent, AddToCart, Purchase…) sont déclenchés depuis services/tracking.ts.

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

const PIXEL_ID = import.meta.env.VITE_FACEBOOK_PIXEL_ID as string | undefined;

let initialized = false;

export function initMetaPixel(): void {
  if (initialized || !PIXEL_ID || typeof window === 'undefined') return;
  initialized = true;

  /* Snippet officiel Meta Pixel (chargeur asynchrone de fbevents.js). */
  /* eslint-disable */
  (function (f: any, b: any, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e);
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq!('init', PIXEL_ID);
  window.fbq!('track', 'PageView');
}

/** Déclenche un événement standard Meta Pixel (no-op si le pixel n'est pas chargé). */
export function trackPixel(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, params);
}

/** Événement personnalisé (hors liste standard Meta) — ex. « Share ». */
export function trackPixelCustom(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('trackCustom', event, params);
}

/** PageView — appelé à chaque changement de route (SPA). */
export function trackPixelPageView(): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'PageView');
}
